<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title="selectedTab" :bodyClass="'p-0'")
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="selected != 'special'")
                DateRangePicker(:value="dateRange" @update="getData")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.d-flex
                SubmitButton(:loading="loading" icon="fa fa-sync" :text="$t('ui.refresh')" isModal=false type="button" @click="getData")
            ul.nav.nav-pills.mb-2
              li.nav-item
                a.nav-link.active#tab-normal(href="#normal" data-toggle="tab" @click="getNormalAnnouncement")
                  span {{ $t("ui.normal") }}
              li.nav-item
                a.nav-link#tab-special(href="#special" data-toggle="tab" @click="getSpecialAnnouncement")
                  span {{ $t("ui.special") }}
              li.nav-item
                a.nav-link#tab-personal(href="#personal" data-toggle="tab" @click="getPersonalMessage")
                  span {{ $t("ui.personal") }}
            .tab-content.rounded.bg-white
              #nav-pt.tab-pane.fade.active.show
            .tab-content.b-row
              table.table.table-sm.table-hover.table-bordered#normal.tab-pane.active(width='100%' role='tabpanel' aria-labelledby='tab-normal')
                thead
                  th.text-center.align-middle.bg-grey-lighter(scope='col' width='5%') {{ $t("ui.no/") }}
                  th.text-center.align-middle.bg-grey-lighter(scope='col' width='5%') {{ $t("ui.id") }}
                  th.align-middle.bg-grey-lighter(scope='col' width='20%') {{ $t("ui.date") }}
                  th.align-middle.bg-grey-lighter(scope='col' width='70%') {{ $t("ui.message") }}
                tbody
                  tr(v-for="(ann, index) in naList.list" :class="index%2===1?'other':'even'")
                    td.text-center(valign='top') {{ index+1 }}
                    td.text-center(valign='top') {{ ann.an_id }}
                    td(valign='top') {{ $moment(ann.an_date).format("MM/DD/YYYY hh:mm A") }}
                    td
                      //- tr.font-weight-bold {{ ann[`subject_${$store.getters.language}`] || ann.subject_en }}
                      tr
                        span.font-weight-bold.mr-1 {{ extractSport(ann['msg_'+ language] || ann.msg_en) }} :
                        span {{ extractMsg(ann['msg_'+ language] || ann.msg_en) }}
                  tr(v-if="naList.list && naList.list.length == 0")
                    td.align-middle.text-center(colspan="4") {{ $t("message.no_information_available") }}
              table.table.table-sm.table-hover.table-bordered#special.tab-pane(width='100%' role='tabpanel' aria-labelledby='tab-special')
                thead
                  th.text-center.align-middle.bg-grey-lighter(scope='col' width='5%') {{ $t("ui.no/") }}
                  th.text-center.align-middle.bg-grey-lighter(scope='col' width='5%') {{ $t("ui.id") }}
                  th.align-middle.bg-grey-lighter(scope='col' width='20%') {{ $t("ui.date") }}
                  th.align-middle.bg-grey-lighter(scope='col' width='70%') {{ $t("ui.message") }}
                tbody
                  tr(v-for="(ann, index) in saList.list" :class="index%2===1?'other':'even'")
                    td.text-center(valign='top') {{ index+1 }}
                    td.text-center(valign='top') {{ ann.an_id }}
                    td(valign='top') {{ $moment(ann.an_date).format("MM/DD/YYYY hh:mm A") }}
                    td
                      //- tr.font-weight-bold {{ ann[`subject_${$store.getters.language}`] || ann.subject_en }}
                      tr
                        span.font-weight-bold.mr-1 {{ extractSport(ann['msg_'+ language] || ann.msg_en) }} :
                        span {{ extractMsg(ann['msg_'+ language] || ann.msg_en) }}
                  tr(v-if="saList.list && saList.list.length == 0")
                    td.align-middle.text-center(colspan="4") {{ $t("message.no_information_available") }}
              table#personal.tab-pane.table.table-sm.table-hover.table-bordered(width='100%' role='tabpanel' aria-labelledby='tab-personal')
                thead
                  th.text-center.align-middle.bg-grey-lighter(scope='col' width='5%') {{ $t("ui.no/") }}
                  th.text-center.align-middle.bg-grey-lighter(scope='col' width='5%') {{ $t("ui.id") }}
                  th.align-middle.bg-grey-lighter(scope='col' width='20%') {{ $t("ui.date") }}
                  th.align-middle.bg-grey-lighter(scope='col' width='70%') {{ $t("ui.message") }}
                tbody
                  tr(v-for="(ann, index) in pmList.list" :class="index%2===1?'other':'even'")
                    td.text-center(valign='top') {{ index+1 }}
                    td.text-center(valign='top') {{ ann.an_id }}
                    td(valign='top') {{ $moment(ann.an_date).format("MM/DD/YYYY hh:mm A") }}
                    td
                      //- tr.font-weight-bold {{ ann[`subject_${$store.getters.language}`] || ann.subject_en }}
                      tr
                        span.font-weight-bold.mr-1 {{ extractSport(ann['msg_'+ language] || ann.msg_en) }} :
                        span {{ extractMsg(ann['msg_'+ language] || ann.msg_en) }}
                  tr(v-if="pmList.list && pmList.list.length == 0")
                    td.align-middle.text-center(colspan="4") {{ $t("message.no_information_available") }}
</template>

<script>
import DateRangePicker from "@/library/DateRangePicker.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    DateRangePicker,
    SubmitButton
  },
  data() {
    return {
      loading: false,
      dateFrom: new Date(new Date().setDate(new Date().getDate() - 7))
        .toISOString()
        .split("T")[0],
      dateTo: new Date().toISOString().split("T")[0],
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      naList: {},
      saList: {},
      pmList: {},
      selected: ""
    };
  },
  computed: {
    dateRange() {
      return {
        // startDate: this.$moment().subtract(72, "hours").format("YYYY-MM-DD"),
        // endDate: this.$moment().subtract(12, "hours").format("YYYY-MM-DD")
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      };
    },
    selectedTab() {
      switch (this.selected) {
        case "normal":
          return this.$t("ui.normal_announcements");
        case "special":
          return this.$t("ui.special_announcements");
        case "personal":
          return this.$t("ui.personal_message");
        default:
          return "";
      }
    },
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    }
  },
  watch: {
    dateFrom(val) {
      if (val >= this.dateRange.endDate) {
        this.dateRange.startDate = this.dateRange.endDate;
      }
    },
    dateTo(val) {
      if (val <= this.dateRange.startDate) {
        this.dateRange.endDate = this.dateRange.startDate;
      }
    }
  },
  mounted() {
    if (this.$route.query.redir === "p") {
      this.$store.dispatch("layout/setDateRange", [this.$moment().subtract(72, "hours").format("YYYY-MM-DD"), this.$moment().subtract(12, "hours").format("YYYY-MM-DD")]);
      $("#tab-personal").click();
      this.getPersonalMessage();
    } else this.getNormalAnnouncement();
  },
  methods: {
    getData() {
      if (this.selected === "normal") this.getNormalAnnouncement();
      if (this.selected === "special") this.getSpecialAnnouncement();
      if (this.selected === "personal") this.getPersonalMessage();
    },
    getNormalAnnouncement() {
      this.selected = "normal";
      this.naList = {};
      this.$store
        .dispatch("message/getAnnouncement", {
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          an_type: 1
        })
        .then(res => {
          this.$set(this.naList, "list", res.value);
        });
    },
    getSpecialAnnouncement() {
      this.selected = "special";
      this.saList = {};
      this.$store
        .dispatch("message/getAnnouncement", {
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          an_type: 4
        })
        .then(res => {
          this.$set(this.saList, "list", res.value);
        });
    },
    getPersonalMessage() {
      this.selected = "personal";
      this.pmList = {};
      this.$store
        .dispatch("message/getPersonalMessage", {
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate
        })
        .then(res => {
          this.$set(this.pmList, "list", res.value);
        });
    },
    extractSport(msg) {
      return msg.split(":")[0];
    },
    extractMsg(msg) {
      return msg
        .split(":")
        .slice(1)
        .join(":");
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-content > table.active {
  display: table;
}
.nav-tabs {
  // padding: 15px;
  > li a.active {
    background: lightgrey;
    border-radius: 0;
  }
}important
.tab-content {
  padding: 0 !important;
  margin-bottom: 0 !important;
}
table {
  margin-bottom: 0 !important;
}

.input-group {
  flex-wrap: nowrap !important;
}
</style>